// The portal's service worker URL. The query carries what public/sw.js can't
// look up itself (it has no session and no i18n): the visitor's language, for
// the offline page it caches and for its fallback notification title, and the
// brand name. A new language or brand yields a new script URL, which makes the
// browser install the worker again with the right offline page.
//
// The root layout renders it as <html data-sw="…">, so every client-side
// registration (the registrar, the push toggle) uses the same URL. Registering
// a different URL for the same scope would swap the worker back and forth.
export function serviceWorkerUrl(locale: string, brandName: string): string {
  const q = new URLSearchParams({ locale, brand: brandName });
  return `/sw.js?${q.toString()}`;
}

/** Register (or update to) the URL the root layout chose. Browser only. */
export async function registerPortalServiceWorker(): Promise<ServiceWorkerRegistration> {
  const url = document.documentElement.dataset.sw || "/sw.js";
  return navigator.serviceWorker.register(url, { scope: "/" });
}
